import axios from 'axios';
import config from '../config';
import {store} from '../index';
import {logout, refreshToken} from '../redux/actions/auth';
import {API_PATH} from './apiPath';
import {RESPONSE_CODE, RESPONSE_MESSAGE} from '../constants';

export const apiLogRequest = (apiName: any, axiosRequest: any) => {
  console.group &&
  console.group(
    '%cAPI Request',
    'color:white;font-weight:bold;background:#0194ff;padding:2px 6px',
    apiName
  );
  console.log('HTTP Method\t\t', axiosRequest.method.toUpperCase());
  console.log('Endpoint\t\t', axiosRequest.url);
  axiosRequest.data && console.log('Request Body\t', axiosRequest.data);
  console.log('AXIOS Request\t', axiosRequest);
  console.groupEnd && console.groupEnd();
};

export const apiLogResponse = (apiName: any, axiosResponse: any) => {
  console.log(axiosResponse);
  console.group &&
  console.group(
    '%cAPI Response',
    'color:white;font-weight:bold;background:green;padding:2px 6px',
    apiName
  );
  console.log('HTTP Method\t\t', axiosResponse.config.method.toUpperCase());
  console.log('Endpoint\t\t', axiosResponse.config.url);
  axiosResponse.config.data && console.log('Request Body\t', axiosResponse.config.data);
  axiosResponse.data && console.log('Response Body\t', axiosResponse.data);
  console.log('AXIOS Response\t', axiosResponse);
  console.groupEnd && console.groupEnd();
};

export const apiLogError = (apiName: any, error: any) => {
  console.log('error', error);
  console.group &&
  console.group(
    '%cAPI Response',
    'color:white;font-weight:bold;background:red;padding:2px 6px',
    apiName
  );
  console.log('HTTP Method\t\t', error.config.method.toUpperCase());
  console.log('Endpoint\t\t', error.config.url);
  error && error.config.data && console.log('Request Body\t', error.config.data);
  error && error.data && console.log('Response Body\t', error.data);
  console.log('AXIOS Error\t', error);
  console.groupEnd && console.groupEnd();
};

const client = axios.create({
  baseURL: config.axiosConfig().baseURL,
  timeout: 45000,
  headers: {
    'Content-Type': 'application/json',
  },
});

client.interceptors.request.use(
  (request: any) => {
    const {token, tokenType, expertTime} = store.getState().auth;
    if (token && expertTime && expertTime < Date.now() && request.url !== `/oauth/token`) {
      store.dispatch(refreshToken())
    }
    if (request.headers && token && !request.setToken) request.headers.Authorization = tokenType + " " + token;
    return request;
  }
);

client.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      if (error.response.config.url === `/oauth/token` && window.location.pathname !== '/') {
        localStorage.clear();
        window.location.replace(``)
      }
      if (error.response.config.url !== `/oauth/token`
        && error.response.config.url !== `/oauth/pharmacy/forgot-password`
        && error.response.data.error === "invalid_token") {
        const auth = store.getState().auth;
        if (auth.refreshToken === null && auth.userInfo === null) return;
        return store.dispatch(refreshToken())
      }
    }
    if (error.response && error.response.status === RESPONSE_CODE.ERROR) {
      if (error.response.config.url === API_PATH.GET_TOKEN && error.response.data.error === RESPONSE_MESSAGE.INVALID_GRANT) {
        store.dispatch(logout());
      }
    }
    if (process.env.NODE_ENV === "development") {
      if (error.response) {
        const apiName = error.config.apiName || 'UNKNOWN';
        apiLogError(apiName, error.response);
      } else if (error.request) {
        const apiName = error.config.headers['X_HEADER_API_LOG'] || 'UNKNOWN';
        apiLogError(apiName, error.request);
      } else {
        console.log('API Error', error.message);
      }
    }
    throw error;
  }
)

// enable request logging for dev
if (process.env.NODE_ENV === 'development') {
  client.interceptors.request.use(
    request => {
      const apiName = 'UNKNOWN';
      apiLogRequest(apiName, request);
      return request;
    },
    error => {
      console.log('API Error', error);
      return error;
    }
  );

  client.interceptors.response.use(
    response => {
      apiLogResponse("UNKNOWN", response)
      return response;
    }
  );
}

export const clientCRM = axios.create({
  baseURL: config.axiosConfig().baseURL_CRM,
  timeout: 45000,
  responseType: 'json',
});

// enable request logging for dev
if (process.env.NODE_ENV === 'development') {
  clientCRM.interceptors.request.use(
    request => {
      const apiName = 'UNKNOWN';
      apiLogRequest(apiName, request);
      return request;
    },
    error => {
      console.log('API Error', error);
      return error;
    }
  );

  clientCRM.interceptors.response.use(
    response => {
      apiLogResponse("UNKNOWN", response)
      return response;
    },
    error => {
      if (error.response) {
        const apiName = error.config.apiName || 'UNKNOWN';
        apiLogError(apiName, error.response);
      } else if (error.request) {
        const apiName = error.config.headers['X_HEADER_API_LOG'] || 'UNKNOWN';
        apiLogError(apiName, error.request);
      } else {
        console.log('API Error', error.message);
      }
      throw error;
    }
  );
}

export default client;
